import { OrderType, useBlogContext } from 'context/BlogContext';
import { Dropdown, OnChangeType } from 'dropdown';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import styled from 'styled-components';
import SearchForm from './SearchForm';

const orderValues = [
  {
    order: 'DESC',
    orderBy: 'post_view_count',
    label: '조회수 순',
    value: 'post_view_count',
    en_label: 'Sort by views',
  },
  {
    orderBy: 'date',
    order: 'ASC',
    label: '오래된 순',
    value: 'date_asc',
    en_label: 'Sort by oldest',
  },
  {
    orderBy: 'date',
    order: 'DESC',
    label: '최신 순',
    value: 'date_desc',
    en_label: 'Sort by newest',
  },
];
const getNextOrderValueByOrder = (order, orderBy) =>
  orderValues.find(v => v.orderBy === orderBy && v.order === order);

const SearchArea = () => {
  const { locale } = useRouter();
  const {
    state: { orderBy, order },
    dispatch,
  } = useBlogContext();
  const orderValue = useMemo(
    () => getNextOrderValueByOrder(order, orderBy),
    [order, orderBy]
  );

  const handleChangeOrder: OnChangeType = (e, value) => {
    const nextOrderValue = orderValues.find(v => v.value === value);
    dispatch({
      type: 'change',
      newState: {
        orderBy: nextOrderValue.orderBy as OrderType,
        order: nextOrderValue.order as 'DESC' | 'ASC',
      },
    });
  };

  return (
    <SearchAreaContainer>
      {/* order by */}
      <Dropdown
        disabled={false}
        changeStyle
        displayBorder={false}
        onChange={handleChangeOrder}
        isPositionFixed={false}
      >
        <Dropdown.Toggle>
          {locale === 'en' ? orderValue.en_label : orderValue.label}
        </Dropdown.Toggle>
        <Dropdown.OptionList>
          <Dropdown.OptionItem
            selected={'date_desc' === orderValue.value}
            disabled={'date_desc' === orderValue.value}
            value="date_desc"
            label={locale === 'en' ? 'Sort by newest' : '최신 순'}
            tabIndex={-1}
          >
            <OrderByOptionItemButton>
              {locale === 'en' ? 'Sort by newest' : '최신 순'}
            </OrderByOptionItemButton>
          </Dropdown.OptionItem>
          <Dropdown.OptionItem
            selected={'date_asc' === orderValue.value}
            disabled={'date_asc' === orderValue.value}
            value="date_asc"
            label={locale === 'en' ? 'Sort by oldest' : '오래된 순'}
            tabIndex={-1}
          >
            <OrderByOptionItemButton>
              {locale === 'en' ? 'Sort by oldest' : '오래된 순'}
            </OrderByOptionItemButton>
          </Dropdown.OptionItem>

          <Dropdown.OptionItem
            selected={'post_view_count' === orderValue.value}
            disabled={'post_view_count' === orderValue.value}
            value="post_view_count"
            label={locale === 'en' ? 'Sort by views' : '조회수 순'}
            tabIndex={-1}
          >
            <OrderByOptionItemButton>
              {locale === 'en' ? 'Sort by views' : '조회수 순'}
            </OrderByOptionItemButton>
          </Dropdown.OptionItem>
        </Dropdown.OptionList>
      </Dropdown>

      {/* search form */}
      <SearchForm />
    </SearchAreaContainer>
  );
};

export default SearchArea;

export const SearchAreaContainer = styled.div`
  padding: 24px 0 32px;
  display: flex;
  justify-content: space-between;
`;

export const OrderByOptionItemButton = styled.button`
  font-family: 'Noto Sans KR';
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
`;
